import { CaretRight, UserCircleGear } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";

const ProfileSettings = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-row items-center justify-between px-5 py-[15px]">
      <div className="flex flex-row items-center gap-2">
        <UserCircleGear size={24} color="white" />
        <span className="font-base font-medium text-white">
          {t("label.profile_settings")}
        </span>
      </div>

      <CaretRight size={20} color="#E3EDFC" />
    </div>
  );
};

export default ProfileSettings;
